import Button from '@ingka/button';
import { useTranslation } from 'react-i18next';
import {
  Children,
  Content,
  ImageWrapper,
  Title,
  Wrapper,
  SlideShowWrapperliveshows,
  Label,
} from './style';
import AspectRatioImage from '../AspectRatioImage';
import styled from 'styled-components';
import { formatDateTime } from '../../utils/formatDate';
import calendarIcon from '@ingka/ssr-icon/paths/calendar';

type PropsType = {
  title: string;
  backgroundImage: {
    src: string;
    srcSet: string;
    ratio: 'square' | 'standard' | 'wide' | 'portrait';
    loading?: string;
  };
  description: string;
  buttonText: string;
  eventPath: string;
  inSlideShow: boolean;
  label: string; // Add the 'label' property
};

const CarouselWrapperLive = styled.div`
  background: rgb(var(--colour-neutral-2, 245, 245, 245))
`;


const LiveBroadcastCard = ({ title,  // Specify the type for the destructured props
  backgroundImage,
  description,
  buttonText,
  eventPath,
  inSlideShow,
  label,
}: PropsType) => {
  const { t } = useTranslation();
  const WrapperElement = inSlideShow ? SlideShowWrapperliveshows : Wrapper;
  return (
    <CarouselWrapperLive>
      <WrapperElement>
        <Content>
          <Label>{formatDateTime(label, '')}</Label>
          <Title alt-text={title}>{title}</Title>
          <Children>{description}</Children>

        </Content>
        <ImageWrapper>
          <AspectRatioImage
            src={backgroundImage.src}
            srcSet={backgroundImage.src}
              
            ratio={backgroundImage.ratio}
            loading={backgroundImage.loading}
            alt=""
          />
        </ImageWrapper>

      </WrapperElement>
      <Button onClick={() => window.location.href = eventPath} 
        type="primary" 
        text={t('event.readMore')} 
        style={{ margin: '20px' }} 
        ssrIcon={calendarIcon}>
        {buttonText}
      </Button>
    </CarouselWrapperLive>
  );
};

export default LiveBroadcastCard;